<template>
  <span class="ringValText_item">
    <span
      class="ringValText_bg"
      :style="{
        width: `calc(${widthVw}vw * ${cssDynamicObj.mixvw})`,
        height: `calc(${widthVw}vw * ${cssDynamicObj.mixvw})`,
        '--mixtmt_mixvw': cssDynamicObj.mixvw,
      }"
    >
      <span
        class="ringValTextItem_abs"
        v-text="val[0]"
        :class="val[0] && val[0].length > 2 ? '' : 'bigFontSize'"
      ></span>
    </span>
    <span class="ringValText_name" v-text="val[1]"></span>
  </span>
</template>

<script>
export default {
  name: 'RingValTextItem',
  props: {
    val: {
      type: Array,
      default: () => {
        return ['', '']
      },
    },
    widthVw: {
      type: Number,
      default: 6.25,
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.ringValText_item {
  width: 100%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  .ringValText_bg {
    position: relative;
    display: block;
    border-radius: 50%;
    background-color: var(--mixtmt_whiteColor);
    border: 1px solid var(--mixtmt_mainColor);
    .ringValTextItem_abs {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      width: calc(100% - 0.694vw * var(--mixtmt_mixvw));
      height: calc(100% - 0.694vw * var(--mixtmt_mixvw));
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background: linear-gradient(
        180deg,
        var(--mixtmt_theme_defaultGradient_1_1) 0%,
        var(--mixtmt_theme_defaultGradient_1_2) 98%
      );
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      color: var(--mixtmt_whiteColor);
      font-weight: bold;
      font-size: calc(1.388vw * var(--mixtmt_mixvw));
      &.bigFontSize {
        font-size: calc(2.788vw * var(--mixtmt_mixvw));
      }
    }
  }
  .ringValText_name {
    padding-top: calc(0.694vw * var(--mixtmt_mixvw));
    font-size: calc(1.11vw * var(--mixtmt_mixvw));
    color: var(--mixtmt_greyColor2);
    text-align: center;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
